import { createSlice } from "@reduxjs/toolkit";
import { fetchAllPharmacyList } from "../../apis/pharmacy/allPharmacyListForSelectBoxInPatientConsent";

const initialState = {
    loading: false,
    data: null,
    error: null
}

const allPharmacyListSlice = createSlice({
    name: 'fetchAllPharmacyList',
    initialState,

    extraReducers: (builder) => {
        builder.addCase(fetchAllPharmacyList.pending.type, (state) => {
            return {
                ...state,
                loading: true,
                data: null,
                error: null
            }
        })

        builder.addCase(fetchAllPharmacyList.fulfilled.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            }
        })

        builder.addCase(fetchAllPharmacyList.rejected.type, (state, action) => {
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload
            }
        })
    }

})

export default allPharmacyListSlice.reducer